import React from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import OutboundLink from '../OutboundLink';
import LandingPageSection from '../LandingPageSection';
import styles from './styles.sass';
import {
  appStoreLink,
  playStoreLink,
} from '../../../helpers/serverRenderingUtils';

export default function MarketingFooter({ campaign }) {
  return (
    <LandingPageSection
      headerBgColor="#8940FA"
      title="Available everywhere"
      subtitle="Get started with Anchor"
    >
      <Grid className={styles.platformSection}>
        <Row>
          <Col lg={6} lgPush={6} className={styles.platformDescription}>
            <h5>Mobile apps</h5>
            <p>
              Works on iPhones, iPads, and Android devices of all shapes and
              sizes.
            </p>
          </Col>
          <Col md={6} lg={3} lgPull={6} className={styles.logoLeft}>
            <OutboundLink to={appStoreLink(campaign)} newWindow>
              <img
                alt="App Store"
                src="https://d12xoj7p9moygp.cloudfront.net/images/appstore-logo.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/appstore-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/appstore-logo@2x.png 2x"
                width={225}
                height={67}
              />
            </OutboundLink>
          </Col>
          <Col md={6} lg={3} lgPull={6} className={styles.logoRight}>
            <OutboundLink to={playStoreLink()} newWindow>
              <img
                alt="Google Play Store"
                src="https://d12xoj7p9moygp.cloudfront.net/images/playstore-logo.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/playstore-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/playstore-logo@2x.png 2x"
                width={230}
                height={69}
              />
            </OutboundLink>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr className={styles.spacer} />
          </Col>
        </Row>
        <Row>
          <Col lg={6} lgPush={6} className={styles.platformDescription}>
            <h5>Smart speakers</h5>
            <p>The easiest way to hear Anchor when you’re at home.</p>
          </Col>
          <Col md={6} lg={3} lgPull={6} className={styles.logoLeft}>
            <div
              className={`${styles.logoWithQuote} ${styles.logoWithQuoteAlexa}`}
            >
              <img
                alt="Amazon Alexa"
                src="https://d12xoj7p9moygp.cloudfront.net/images/alexa-logo.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/alexa-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/alexa-logo@2x.png 2x"
                width={223}
                height={71}
              />
            </div>
          </Col>
          <Col md={6} lg={3} lgPull={6} className={styles.logoRight}>
            <div className={styles.logoWithQuote}>
              <img
                alt="Google Home"
                src="https://d12xoj7p9moygp.cloudfront.net/images/googlehome-logo.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/googlehome-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/googlehome-logo@2x.png 2x"
                width={232}
                height={54}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr className={styles.spacer} />
          </Col>
        </Row>
        <Row>
          <Col lg={6} lgPush={6} className={styles.platformDescription}>
            <h5>In your car</h5>
            <p>
              Turns out, people like to listen to stuff while they’re driving.
            </p>
          </Col>
          <Col md={12} lg={6} lgPull={6} className={styles.logoLeft}>
            <p className={styles.autoComingSoon}>
              Connect Anchor to your car with Bluetooth. Official integrations
              coming soon.
            </p>
          </Col>
        </Row>
      </Grid>
    </LandingPageSection>
  );
}
